export enum CountryEnum {
  BRAZIL = "BRASIL",
  ARGENTINA = "ARGENTINA",
  UNITED_STATES = "UNITED STATES",
  NEDERLANDS = "NEDERLANDS"
}

export enum CountryCodeEnum {
  BRAZIL = "BR",
  ARGENTINA = "AR",
  UNITED_STATES = "US",
  NEDERLANDS = "NL"
}
